/** Branch delivery mode — single DB field; HYBRID = online + offline. */
import i18n from '../i18n';

const BRANCH_MODE_VALUES = ['OFFLINE', 'ONLINE', 'HYBRID'];

export function getBranchModeOptions() {
  return BRANCH_MODE_VALUES.map((value) => ({
    value,
    label: i18n.t(`branchModes.${value}.label`),
    description: i18n.t(`branchModes.${value}.description`),
  }));
}

export function formatBranchMode(mode) {
  if (mode && i18n.exists(`branchModes.${mode}.label`)) {
    return i18n.t(`branchModes.${mode}.label`);
  }
  return mode ?? '—';
}

/** Physical address is optional for pure online branches only. */
export function branchShowsAddress(mode) {
  return mode !== 'ONLINE';
}
